import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoadingTextComponent } from '@freelancer/components/loading-text';
import { CardComponent } from '@freelancer/ui/card';
import { LoadingAvatarComponent } from '@freelancer/ui/loading-avatar';
import { AvatarSize } from '@freelancer/ui/user-avatar';

@Component({
  standalone: true,
  imports: [
    CardComponent,
    LoadingAvatarComponent,
    LoadingTextComponent,
    NgTemplateOutlet,
  ],
  selector: 'fl-loading-avatar-row-card',
  template: `
    @if (card) {
      <fl-card>
        <ng-container [ngTemplateOutlet]="body" />
      </fl-card>
    } @else {
      <ng-container [ngTemplateOutlet]="body" />
    }

    <ng-template #body>
      <div class="Body">
        <!-- TODO: T333982 - Replace the fixed 152px wrapper with the real avatar
             dimensions once design confirms the spec. -->
        <div
          class="Body-avatar"
          [class.Body-avatar--max]="avatarSize === AvatarSize.MAX"
        >
          <fl-loading-avatar
            [size]="avatarSize"
            [sizeDesktop]="avatarSizeDesktop"
          />
        </div>
        <fl-loading-text [rows]="bodyRows" />
      </div>
    </ng-template>
  `,
  styleUrls: ['./loading-avatar-row-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingAvatarRowCardComponent {
  AvatarSize = AvatarSize;

  @Input() avatarSize: AvatarSize = AvatarSize.MAX;

  /**
   * Optional avatar size applied from the desktop breakpoint up. Leave unset to
   * keep `avatarSize` at all breakpoints.
   */
  @Input() avatarSizeDesktop?: AvatarSize;

  /** Rows of loading text rendered alongside the avatar. */
  @Input() bodyRows = 2;

  /** Wrap the avatar row in an `fl-card`. Set `false` when the parent surface already provides its own card/background. */
  @Input() card = true;
}
